var React = require('react');
var CategoryRow = require('CategoryRow');
var CategoriesTable = React.createClass({
    render: function() {

        var rows = this.props.categories
            .map(function(category, i) {
                return (
                    <CategoryRow
                    key={i}
                    category={category}
                    changeAppMode={this.props.changeAppMode} />
                    );
            }.bind(this));

        return (
        !rows.length
            ? <div className='col-sm-3 alert alert-danger'>No categories found.</div>
            :<div className="col-lg-2 col-md-4 col-sm-6">
            <div className="card-box widget-box-one">
                <div className="wigdet-one-content">
                    <h4 className="text-dark"><span> {rows}</span></h4>
                </div>
            </div>
        </div>

        );
    }
});

module.exports = CategoriesTable;


// WEBPACK FOOTER //
// ./react/app/components/CategoriesTable.jsx